import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=6591c549&scoped=true&"
import script from "./DataManagement.vue?vue&type=script&lang=js&"
export * from "./DataManagement.vue?vue&type=script&lang=js&"
import style0 from "./DataManagement.vue?vue&type=style&index=0&id=6591c549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6591c549",
  null
  
)

export default component.exports